(function () {
  'use strict';

  function getHeaderGroup() {
    var lock = document.getElementById('hero-chrome-lock');
    if (lock) return lock;

    var wrapper = document.getElementById('shopify-section-group-header-group');
    if (wrapper) return wrapper;

    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    if (!sections.length) return null;

    var wrap = document.createElement('div');
    wrap.id = 'hero-chrome-lock';
    sections[0].parentNode.insertBefore(wrap, sections[0]);
    for (var i = 0; i < sections.length; i++) {
      wrap.appendChild(sections[i]);
    }
    return wrap;
  }

  function getHeaderArea() {
    return document.querySelector('.header1 .header-area');
  }

  function measureChromeHeight() {
    var height = 0;
    var topBar = document.querySelector('.top-bar3');
    var header = document.querySelector('header.header1') || document.querySelector('.header1');
    if (topBar && window.getComputedStyle(topBar).display !== 'none') {
      height += topBar.offsetHeight;
    }
    if (header && window.getComputedStyle(header).display !== 'none') {
      height += header.offsetHeight;
    }
    if (!height) {
      var area = getHeaderArea();
      if (area) height += area.offsetHeight;
    }
    return Math.round(height) || 0;
  }

  function scrollDistancePx(root) {
    var raw = getComputedStyle(root).getPropertyValue('--hero-scroll-distance').trim();
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    var value = parseFloat(raw);
    if (!value) value = 220;
    if (raw.indexOf('vh') !== -1) return (value / 100) * viewH;
    return value;
  }

  function setChromeLocked(locked, chromeH) {
    var group = getHeaderGroup();
    var headerArea = getHeaderArea();
    var spacer = document.getElementById('hero-chrome-spacer');
    document.body.classList.toggle('hero-chrome-locked', !!locked);

    if (headerArea) {
      headerArea.classList.remove('sticky', 'sticky-down', 'sticky-up');
      headerArea.style.setProperty('transform', 'none', 'important');
      headerArea.style.setProperty('position', 'relative', 'important');
      headerArea.style.setProperty('top', 'auto', 'important');
    }

    if (!group) return;

    if (locked) {
      group.classList.add('is-hero-locked');
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.id = 'hero-chrome-spacer';
        group.parentNode.insertBefore(spacer, group.nextSibling);
      }
      spacer.style.height = chromeH + 'px';
    } else {
      group.classList.remove('is-hero-locked');
      if (spacer) spacer.style.height = '0px';
      if (headerArea) {
        headerArea.style.removeProperty('transform');
        headerArea.style.removeProperty('position');
        headerArea.style.removeProperty('top');
      }
    }
  }

  function initHero(root) {
    if (!root || root.dataset.heroInit === 'true') return;
    root.dataset.heroInit = 'true';

    var pinWrap = root.querySelector('[data-hero-pin-wrap]');
    var panel = root.querySelector('[data-hero-sticky]');
    var media = root.querySelector('[data-hero-media]');
    var canvas = root.querySelector('[data-hero-canvas]');
    var frameNodes = root.querySelectorAll('[data-hero-frame]');
    var bgVideo = root.querySelector('[data-hero-bg-video]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!pinWrap || !panel || !canvas || !frameNodes.length) return;

    if (bgVideo) {
      bgVideo.muted = true;
      bgVideo.defaultMuted = true;
      bgVideo.playsInline = true;
      bgVideo.setAttribute('muted', '');
      bgVideo.setAttribute('playsinline', '');
      var playBg = bgVideo.play();
      if (playBg && typeof playBg.catch === 'function') {
        playBg.catch(function () {});
      }
    }

    var ctx = canvas.getContext('2d');
    var frames = [];
    var frameCount = frameNodes.length;
    var startFrame = parseInt(media.getAttribute('data-hero-frame-start') || '0', 10);
    if (isNaN(startFrame) || startFrame < 0) startFrame = 0;
    if (startFrame > frameCount - 2) startFrame = Math.max(0, frameCount - 2);
    var scrubCount = frameCount - startFrame;
    var currentIndex = -1;
    var chromeH = 0;
    var lockState = null;
    var ticking = false;
    var frameAspect = 1000 / 800;

    for (var i = 0; i < frameNodes.length; i++) {
      frames.push(frameNodes[i]);
    }

    var lastDrawW = 0;
    var lastDrawH = 0;

    function sizeCanvas() {
      var maxW = Math.max(1, media.clientWidth || media.getBoundingClientRect().width);
      var maxH = Math.max(1, (media.clientHeight || media.getBoundingClientRect().height) * 0.85);
      var drawW;
      var drawH;

      if (maxW / maxH > frameAspect) {
        drawH = maxH;
        drawW = maxH * frameAspect;
      } else {
        drawW = maxW;
        drawH = maxW / frameAspect;
      }

      drawW = Math.round(drawW);
      drawH = Math.round(drawH);
      if (drawW === lastDrawW && drawH === lastDrawH) return false;

      lastDrawW = drawW;
      lastDrawH = drawH;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.style.width = drawW + 'px';
      canvas.style.height = drawH + 'px';
      canvas.width = Math.max(1, Math.round(drawW * dpr));
      canvas.height = Math.max(1, Math.round(drawH * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      currentIndex = -1;
      return true;
    }

    function ensureImgSrc(img) {
      if (!img) return;
      if (!img.src && img.dataset.src) {
        img.src = img.dataset.src;
      }
    }

    function drawFrame(index) {
      index = Math.max(0, Math.min(frameCount - 1, index));
      if (index === currentIndex) return;

      var img = frames[index];
      if (!img) return;
      ensureImgSrc(img);

      function paint() {
        if (!img.naturalWidth) return;
        currentIndex = index;
        var cw = canvas.clientWidth || canvas.width;
        var ch = canvas.clientHeight || canvas.height;
        if (!cw || !ch) return;

        var ir = img.naturalWidth / img.naturalHeight;
        var dw;
        var dh;
        var dx;
        var dy;

        if (ir > cw / ch) {
          dw = cw;
          dh = cw / ir;
          dx = 0;
          dy = (ch - dh) / 2;
        } else {
          dh = ch;
          dw = ch * ir;
          dx = (cw - dw) / 2;
          dy = 0;
        }

        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(img, dx, dy, dw, dh);
      }

      if (img.complete && img.naturalWidth) {
        paint();
      } else {
        img.addEventListener('load', paint, { once: true });
        if (typeof img.decode === 'function') {
          img.decode().then(paint).catch(function () {});
        }
      }
    }

    function preloadAround(index) {
      var start = Math.max(0, index - 4);
      var end = Math.min(frameCount - 1, index + 8);
      for (var i = start; i <= end; i++) {
        var img = frames[i];
        if (img) {
          ensureImgSrc(img);
          if (!img.complete) {
            img.loading = 'eager';
            var _ = img.naturalWidth;
          }
        }
      }
    }

    var isMobileQuery = window.matchMedia('(max-width: 991px)');

    function isMobile() {
      return isMobileQuery.matches;
    }

    function setLock(locked) {
      if (isMobile()) {
        locked = false;
      }
      if (lockState === locked) return;
      lockState = locked;
      setChromeLocked(locked, chromeH);
    }

    function update() {
      if (isMobile()) {
        setLock(false);
        pinWrap.style.height = '';
        panel.style.height = '';
        panel.style.top = '';
        panel.classList.remove('is-fixed', 'is-bottom');
        return;
      }

      chromeH = measureChromeHeight();
      var viewH = window.innerHeight || document.documentElement.clientHeight;
      var panelH = Math.max(1, Math.round(viewH - chromeH));
      var distance = Math.max(1, scrollDistancePx(root));
      var progress = 0;

      if (reduceMotion.matches) {
        progress = 1;
      } else {
        var pinTop = pinWrap.getBoundingClientRect().top;
        progress = Math.min(1, Math.max(0, (chromeH - pinTop) / distance));
      }

      // Hold first/last frames at the ends; scrub only in the middle ~76%
      var startTrim = 0.12;
      var endTrim = 0.12;
      var animProgress = 0;
      if (progress <= startTrim) {
        animProgress = 0;
      } else if (progress >= 1 - endTrim) {
        animProgress = 1;
      } else {
        animProgress = (progress - startTrim) / Math.max(0.0001, 1 - startTrim - endTrim);
      }

      root.style.setProperty('--hero-chrome-offset', chromeH + 'px');
      pinWrap.style.height = panelH + distance + 'px';
      panel.style.height = panelH + 'px';
      sizeCanvas();

      panel.classList.remove('is-fixed', 'is-bottom');
      if (reduceMotion.matches) {
        panel.style.top = '0px';
        setLock(false);
      } else if (progress <= 0.001) {
        panel.style.top = '0px';
        setLock(true);
      } else if (progress >= 0.999) {
        panel.classList.add('is-bottom');
        panel.style.top = '';
        setLock(false);
      } else {
        panel.classList.add('is-fixed');
        panel.style.top = chromeH + 'px';
        setLock(true);
      }

      var index = startFrame + Math.round(animProgress * (scrubCount - 1));
      drawFrame(index);
      preloadAround(index);
    }

    function onScroll() {
      if (isMobile()) return;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    if (!isMobile()) {
      // Draw first usable frame ASAP
      drawFrame(startFrame);
      frames[startFrame].addEventListener('load', function () {
        drawFrame(startFrame);
      });

      // Eager-load first chunk of the scrub range
      for (var p = startFrame; p < Math.min(startFrame + 16, frameCount); p++) {
        ensureImgSrc(frames[p]);
        frames[p].loading = 'eager';
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        currentIndex = -1;
        lockState = null;
        update();
      },
      { passive: true }
    );

    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hero-scar-protocol]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var root =
      (section && section.querySelector && section.querySelector('[data-hero-scar-protocol]')) ||
      section;
    if (root && root.hasAttribute && root.hasAttribute('data-hero-scar-protocol')) {
      delete root.dataset.heroInit;
      initHero(root);
    } else {
      initAll(section);
    }
  });
})();
